import { Injectable, EventEmitter } from '@angular/core';


@Injectable()
export class AddFavoriteNameService {
    favNameUpdated: EventEmitter<string> = new EventEmitter();
    favMealAdded: EventEmitter<boolean> = new EventEmitter();
    public favName: string;
    public navigateFromFav: boolean;
    public favId: string;

    constructor() {
     }

    setNavigateFromFav(navigateFromFav: boolean) {
      this.navigateFromFav = navigateFromFav;
    }

    getNavigateFromFav() {
      const navigateFromFavOldValue = this.navigateFromFav;
      this.navigateFromFav = false;
      return navigateFromFavOldValue;
    }

    setFavname(favName) {
      this.favName = favName;
      this.favNameUpdated.emit(this.favName);
    }

    getFavName() {
      return this.favName;
    }

    setFavId(favId: string) {
      this.favId = favId;
    }

    getFavId() {
      return this.favId;
    }

}
